export const GET_S3_PRE_SIGN_URL = 'GET_S3_PRE_SIGN_URL';
export const GET_FILE_UPLOAED_STATUS = 'GET_FILE_UPLOAED_STATUS';
